import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { certificateTemplate } from "../../store/certificates/actions";
export var GetCertificatesTemplate = function (trigger, enable, page, limit, title, projectId, certType) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingCertificateTemplate: state.Certificates.loadingCertificateTemplate,
        responseCertificateTemplate: state.Certificates.responseCertificateTemplate,
        errorCertificateTemplate: state.Certificates.errorCertificateTemplate,
    }); }), loadingCertificateTemplate = _a.loadingCertificateTemplate, responseCertificateTemplate = _a.responseCertificateTemplate, errorCertificateTemplate = _a.errorCertificateTemplate;
    useEffect(function () {
        if (trigger) {
            dispatch(certificateTemplate({
                title: title,
                enable: enable,
                projectId: projectId,
                certType: certType,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger, title, projectId, certType]);
    return {
        loadingCertificateTemplate: loadingCertificateTemplate,
        responseCertificateTemplate: responseCertificateTemplate,
        errorCertificateTemplate: errorCertificateTemplate,
    };
};
